export const Links = [
  {
    label: 'Produkty',
    sublinks: [
      {
        link: 'tapety-obiektowe',
        label: 'Tapety obiektowe',
      },
      {
        link: 'tapety-dekoracyjne',
        label: 'Tapety dekoracyjne',
      },
      {
        link: 'fototapety',
        label: 'Fototapety',
      },
      {
        link: 'producenci',
        label: 'Producenci',
      },
      {
        link: 'tkaniny',
        label: 'Tkaniny',
      },
      {
        link: 'sztukateria',
        label: 'Sztukateria',
      },
      {
        link: 'panele',
        label: 'Miękkie ściany Fluffo',
      },
      // {
      //   link: 'sztukateria',
      //   label: 'Sztukateria',
      // },
    ],
  },
  // {
  //   link: 'aranzacje',
  //   label: 'Aranżacje',
  // },
  // {
  //   link: 'architekci',
  //   label: 'Architekci',
  // },
  {
    link: 'montaz',
    label: 'Montaż',
  },
  {
    link: 'pomysl-na-lampe',
    label: 'Pomysł na lampę',
  },
  { link: 'realizacje', label: 'Realizacje' },
  // {
  //   link: 'o-nas',
  //   label: 'O nas',
  // },
  {
    link: '#kontakt',
    label: 'Kontakt',
  },
  {
    link: 'https://pl-pl.facebook.com/Najpi%C4%99kniejsze-tapety-w-Koszalinie-ZONA-salon-wyposa%C5%BCenia-wn%C4%99trz-235821219884713/',
    label: 'FB',
    target: 'external',
  },
  {
    link: 'https://www.instagram.com/zonatapety/',
    label: 'IG',
    target: 'external',
  },
];
